/**
 * Toggle de la lista de ajustes. Pista 42 × 24, perilla de 20 px.
 *
 * El cambio es optimista: la perilla se mueve al toque y el llamador revierte
 * si el PUT falla. Los kill switches del portal tienen que sentirse inmediatos
 * — son lo que se toca cuando algo está saliendo mal.
 */
export default function Toggle({ checked, onChange, disabled = false, label }: {
  checked: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
  label: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative h-6 w-[42px] shrink-0 rounded-full transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-ring ${
        checked ? 'bg-brand' : 'bg-surface-border'
      } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
    >
      <span
        className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-knob transition-all duration-150 ${
          checked ? 'left-[19px]' : 'left-0.5'
        }`}
      />
    </button>
  )
}
